// Minnesotaänger Mini App — unified message context menu (v1 rewrite).
// New code (not from telegram-tt). Every user and assistant bubble shares
// this exact menu — Reply → Copy → Select → Reroll → Edit → Delete — with
// the same layout, order and icons (Lucide-style linear icons). Per-item
// disabled state comes from the backend contract (message.actions), never
// invented on the frontend: a blocked item is shown grayed out with no
// click behavior.

import { memo } from '../../../lib/teact/teact';

import type { ApiMiniAppMessage } from '../../../api/miniapp/types';

import type { IAnchorPosition } from '../../../types';

import Menu from '../../ui/Menu';
import MenuItem from '../../ui/MenuItem';

import './MessageContextMenu.scss';

type OwnProps = {
  message: ApiMiniAppMessage;
  // A pending op on this message (reroll/edit/delete in flight, §3.4) disables
  // the mutating items — structure and order stay fixed (§4.2).
  isPendingOp: boolean;
  isOpen: boolean;
  anchor: IAnchorPosition;
  onReply: NoneToVoidFunction;
  onCopy: NoneToVoidFunction;
  onSelect: NoneToVoidFunction;
  onReroll: NoneToVoidFunction;
  onEdit: NoneToVoidFunction;
  onDelete: NoneToVoidFunction;
  onClose: NoneToVoidFunction;
  onCloseAnimationEnd: NoneToVoidFunction;
};

function MessageContextMenu({
  message,
  isPendingOp,
  isOpen,
  anchor,
  onReply,
  onCopy,
  onSelect,
  onReroll,
  onEdit,
  onDelete,
  onClose,
  onCloseAnimationEnd,
}: OwnProps) {
  const isBlocked = (key: keyof ApiMiniAppMessage['actions']) => message.actions[key] === 'blocked';

  return (
    <Menu
      isOpen={isOpen}
      anchor={anchor}
      autoClose
      withPortal
      className="MessageContextMenu"
      onClose={onClose}
      onCloseAnimationEnd={onCloseAnimationEnd}
    >
      <MenuItem icon="reply" disabled={isBlocked('reply')} onClick={onReply}>回复</MenuItem>
      <MenuItem icon="copy" disabled={isBlocked('copy')} onClick={onCopy}>复制</MenuItem>
      <MenuItem icon="select" disabled={isBlocked('select')} onClick={onSelect}>选择</MenuItem>
      <MenuItem icon="rotate" disabled={isBlocked('reroll') || isPendingOp} onClick={onReroll}>重新生成</MenuItem>
      <MenuItem icon="edit" disabled={isBlocked('edit') || isPendingOp} onClick={onEdit}>编辑</MenuItem>
      <MenuItem icon="delete" destructive disabled={isBlocked('delete') || isPendingOp} onClick={onDelete}>删除</MenuItem>
    </Menu>
  );
}

export default memo(MessageContextMenu);
